import React from 'react';
import { classNames } from '@/shared/lib/classnames/classnames';
import { Dialog, DialogContent } from '@/shared/ui/dialog';
import { usePhones } from '../model/store/phones';
import { usePhonesModal } from '../model/store/usePhonesModal';
import { PhoneDialogHeader } from './PhoneDialogHeader';
import { PhonesList } from './PhoneList';
import type { DoctorPhonesProps, PhoneData } from '../model/types';
export const DoctorPhones: React.FC<DoctorPhonesProps> = ({
  sectionId,
  onPhoneCallGtmEvent,
  onClosePhonesGtmEvent,
  doctorId,
  medcenterId,
  title,
  className = ''
}) => {
  const {
    setVisiblePhonesModal,
    visiblePhonesModal,
    modalPhonesId
  } = usePhonesModal();
  const {
    phones: phoneNumbers
  } = usePhones();
  const isModalVisible = visiblePhonesModal && (modalPhonesId === doctorId || modalPhonesId === medcenterId);
  const handleClosePhones = () => {
    setVisiblePhonesModal(false);
    if (onClosePhonesGtmEvent) {
      onClosePhonesGtmEvent();
    }
  };
  const handleCall = (phoneNumber: PhoneData) => {
    if (onPhoneCallGtmEvent) {
      onPhoneCallGtmEvent(phoneNumber);
    }
  };
  return <div className={classNames('flex flex-col md:px-0', {}, [className])} id={sectionId} data-sentry-component="DoctorPhones" data-sentry-source-file="DoctorPhones.tsx">
      <Dialog open={isModalVisible} data-sentry-element="Dialog" data-sentry-source-file="DoctorPhones.tsx">
        <DialogContent removeScrollLock className="md:w-full md:max-w-96" overlayClick={() => setVisiblePhonesModal(false)} variant="modal" data-sentry-element="DialogContent" data-sentry-source-file="DoctorPhones.tsx">
          <PhoneDialogHeader title={title} onClose={handleClosePhones} data-sentry-element="PhoneDialogHeader" data-sentry-source-file="DoctorPhones.tsx" />
          <PhonesList phones={phoneNumbers} onCall={handleCall} data-sentry-element="PhonesList" data-sentry-source-file="DoctorPhones.tsx" />
        </DialogContent>
      </Dialog>
    </div>;
};
export default DoctorPhones;